import { jsx, jsxs } from "react/jsx-runtime";
import {
  Experimental_CssVarsProvider as CssThemeProvider,
  ScopedCssBaseline,
  useColorScheme,
  useMediaQuery
} from "@mui/material";
import { useEffect } from "react";
import { validateTidalLicense } from "../../base/index.js";
import { ColorSchemeProvider, useColorScheme as useTidalColorScheme } from "./ColorSchemeProvider.js";
import { useCreateTidalTheme } from "./useCreateTidalTheme.js";
const emptyStyle = {};
function TidalThemeProvider(props) {
  const { enableUserPreferredColorScheme } = props;
  return /* @__PURE__ */ jsx(ColorSchemeProvider, { enableUserPreferredColorScheme, children: /* @__PURE__ */ jsx(TidalThemeProviderInner, { ...props }) });
}
validateTidalLicense();
function TidalThemeProviderInner(props) {
  const {
    theme: customThemeOptions,
    style = emptyStyle,
    children,
    className = "",
    enableColorScheme = false,
    disableCssBaseLine
  } = props;
  const { mode } = useTidalColorScheme();
  const theme = useCreateTidalTheme(mode, customThemeOptions);
  return /* @__PURE__ */ jsx(CssThemeProvider, { theme, children: disableCssBaseLine ? children : /* @__PURE__ */ jsxs(
    ScopedCssBaseline,
    {
      "data-testid": "tidalScopedCssBaseline",
      style,
      className,
      enableColorScheme,
      children: [
        /* @__PURE__ */ jsx(ReactToColorSchemeUpdates, {}),
        children
      ]
    }
  ) });
}
function ReactToColorSchemeUpdates() {
  const { setMode } = useTidalColorScheme();
  const { mode } = useColorScheme();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  useEffect(() => {
    if (!mode) return;
    setMode(mode === "system" ? prefersDarkMode ? "dark" : "light" : mode);
  }, [setMode, mode, prefersDarkMode]);
  return null;
}
export {
  TidalThemeProvider
};
//# sourceMappingURL=TidalThemeProvider.js.map
